// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Ay","question":"e_By","button":"e_Cy","buttonNegative":"e_Dy","buttonPositive":"e_Ey","icon":"e_Fy","iconNegative":"e_Gy","iconPositive":"e_Hy"};